import _extends from "@babel/runtime/helpers/esm/extends";
import { CoreTypographyThemeVariants } from './typographyVariants';
export var MuiTooltipOverrides = {
  styleOverrides: {
    tooltip: _extends({}, CoreTypographyThemeVariants.body2, {
      backgroundColor: '#252C3A'
    }),
    arrow: {
      color: '#252C3A'
    }
  }
};